<script>
  import mensagemServico from '../servico';
  import projetoServico from '~modulos/projeto/servico';

  import Paginacao from '~componentes/Paginacao.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import Radio from '~componentes/Radio.vue';

  import $ from 'jquery';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  export default {
    components: { Paginacao, ModalArquivosSolicitacao, ModalMensagem, Radio },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        mensagens: [],
        carregando: true,
        mensagemSelecionada: null,
        animated: true,
        configuracao: this.$storage.configuracao(),
        filtros: this.camposFiltros(),
        projetos: [],
        modulos: [],
        modalArquivos: false,
        modalMensagem: false,
        solicitacaoSelecionada: null,
        numeroSolicitacaoSelecionada: null,
        tipo: null,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetos()
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeModulos() {
        return mensagemServico
          .listaDeModulos()
          .then(modulos => {
            this.modulos = modulos;
          });
      },
      camposFiltros() {
        return {
          modulo: '0',
          idProjeto: '0',
          mostrarMensagens: '0',
          numero: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val('0');
          $('#projeto').trigger('change.select2');
        });

        this.$nextTick(() => {
          $('#modulo').val('0');
          $('#modulo').trigger('change.select2');
        });

        this.lista();
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      lista(pagina = 1) {
        this.carregando = true;

        return mensagemServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.mensagens = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      modulo(tipo, descricao = '') {
        switch (tipo) {
          case '1':
            return 'Solicitação de Compra';
          case '2':
            return 'Solicitação de ' + this.configuracao.nomeModuloSolContratos;
          case '3':
            return 'Solicitação de ' + this.configuracao.nomeModuloSolCursoEventoServico;
          case '4':
            if (descricao.indexOf("@") != -1)
              return 'Solicitação de Pagamento Estrangeiro PF';
            else
              return 'Solicitação de Pagamento Pessoa Física';
          case '5':
            return 'Solicitação de Adiantamento';
          case '6':
            let passagem = this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '';
            let adiantamento = this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '';
            let estrangeiro = (descricao.indexOf("@") != -1) ? ' - Estrangeiro' : '';
            
            return this.textoTipoMensagem = 'Solicitação de Diária ' + passagem + adiantamento + estrangeiro;
          case '7':
            return 'Solicitação de Faturamento';
          case '9':
            if (descricao.indexOf("@") != -1)
              return 'Solicitação de Pagamento Estrangeiro PJ';
            else
              return 'Solicitação de Pagamento Pessoa Jurídica';
          case '10':
            return 'Solicitação de Reembolso Terceiro';
          case '15':
            return 'Solicitação de Transferência';
          case '16':
            return 'Solicitação Cancelamento Contrato';
          case '18':
            return "Solicitação de Contratação Pessoal";
          default:
            return '';
        }
      },
      mostrarModalArquivos(solicitacao, tipo) {
        this.solicitacaoSelecionada = solicitacao;
        this.tipo = tipo;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
        this.tipo = null;
      },
      mostrarModalMensagem(solicitacao, numeroSolicitacao, tipo) {
        this.solicitacaoSelecionada = solicitacao;
        this.numeroSolicitacaoSelecionada = numeroSolicitacao;
        this.tipo = tipo;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.numeroSolicitacaoSelecionada = null;
        this.tipo = null;
        this.lista(this.pagina);
      },
      relatorio(tipo, descricao = '', tipoSolicitacao = 0) {
        switch (tipo) {
          case '1':
            return 'solicitacao-compra.relatorio';
          case '2':
            return 'solicitacao-bolsa.relatorio';
          case '3':
            return 'solicitacao-curso-evento-servico.relatorio';
          case '4':
            if (descricao.indexOf("@") != -1)
              return 'solicitacao-pagamento-estrangeiro-pf.relatorio';
            else
              return 'solicitacao-pagamento-pf.relatorio';
          case '5':
            return 'solicitacao-adiantamento.relatorio';
          case '6':
            if (descricao.indexOf("@") != -1)
              return 'solicitacao-reembolso-estrangeiro.relatorio';
            else
              return 'solicitacao-reembolso-pf.relatorio';
          case '7':
            switch (tipoSolicitacao) {
              case 2:
                return 'solicitacao-faturamento-estrangeiro-pf.relatorio';
              case 3:
                return 'solicitacao-faturamento-estrangeiro-pj.relatorio';
              default:
                return 'solicitacao-faturamento-pfpj.relatorio';
            };
          case '9':
            if (descricao.indexOf("@") != -1)
              return 'solicitacao-pagamento-estrangeiro-pj.relatorio';
            else
              return 'solicitacao-pagamento-pj.relatorio';
          case '10':
            return 'solicitacao-reembolso-terceiro.relatorio';
          case '15':
            return 'solicitacao-transferencia.relatorio';
          case '16':
            return 'solicitacao-cancelamento-contrato.relatorio';
          case '18':
            return 'solicitacao-contratacao-pessoal.relatorio';
          default:
            return '';
        }
      },
      modalMensagemTipo(tipo) {
        switch (tipo) {
          case '1':
            return 'SolCompra';
          case '2':
            return 'SolBolsa';
          case '3':
            return 'SolCursoEventoServico';
          case '4':
            return 'SolPagamentoPF';
          case '5':
            return 'SolAdiantamento';
          case '6':
            return 'SolReembolso';
          case '7':
            return 'SolFaturamento';
          case '9':
            return 'SolPagamentoPJ';
          case '10':
            return 'SolReembolsoTerceiro';
          case '15':
            return 'SolTransferencia';
          case '16':
            return 'SolCancelamentoContrato';
          case '18':
            return 'SolContratacaoPessoal';
          default:
            return '';
        }
      },
      modalArquivoTipo(tipo) {
        switch (tipo) {
          case '1':
            return 'compra';
          case '2':
            return 'bolsa';
          case '3':
            return 'cursoeventoservico';
          case '4':
            return 'pagamento';
          case '5':
            return 'adiantamento';
          case '6':
            return 'reembolso';
          case '7':
            return 'faturamento';
          case '9':
            return 'pagamento';
          case '10':
            return 'reembolso-terceiro';
          case '15':
            return 'transferencia';
          case '16':
            return 'cancelamentocontrato';
          case '18':
            return 'contratacao-pessoal';
          default:
            return '';
        }
      },
    },
    created() {
      if (this.$route.params.filtrosBag) 
        this.filtros = this.$route.params.filtrosBag;

      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Mensagens Sistema - Lista';
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();
      this.listaDeModulos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function (e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
        });

      $('#modulo').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'modulo', this.value);
        });

      if (this.$route.params.filtrosBag)
        $('.ibox').removeClass('collapsed');
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada : ''"
                                :tipo="modalArquivoTipo(tipo)"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-mensagem :mostrar="modalMensagem"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada : 0"
                                :numero="numeroSolicitacaoSelecionada ? numeroSolicitacaoSelecionada : ''"
                                :tipo="modalMensagemTipo(tipo)"
                                @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins" id="filter">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="modulo">Módulo</label>

                  <select id="modulo"
                          class="form-control"
                          v-model="filtros.modulo">
                    <option value="0">Todos</option>
                    <option :value="modulo.id" v-for="(modulo, index) in modulos">{{ modulo.tipo }}</option>
                  </select>
                </div>
              </div>

              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="numero">Número</label>

                  <input type="text"
                         class="form-control"
                         id="numero"
                         v-model="filtros.numero"
                         v-numero>
                </div>
              </div>
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label block">Mostrar mensagens</label>

                  <radio v-model="filtros.mostrarMensagens"
                         selected-value="0"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Todas
                  </radio>
                  <radio v-model="filtros.mostrarMensagens"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Não lidas
                  </radio>
                  <radio v-model="filtros.mostrarMensagens"
                         selected-value="2"
                         type="success"
                         :inline="true">
                    Lidas
                  </radio>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">
            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Não lidas</th>
                    <th class="text-center">Número</th>
                    <th>Módulo</th>
                    <th>Projeto</th>
                    <th>Data última mensagem</th>
                    <th>Usuário última mensagem</th>
                    <th>Descrição</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mensagem, index) in mensagens">
                    <td>
                      <div v-if="mensagem.quantidadeNaoLida > 0">
                        <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{mensagem.quantidadeNaoLida}}
                      </div>
                    </td>
                    <td class="text-center">{{ mensagem.numero || '---' }}</td>
                    <td>{{ modulo(mensagem.modulo, mensagem.descricao) }}</td>
                    <td>{{ mensagem.projeto || '---' }}</td>
                    <td>{{ mensagem.data || '---' }}</td>
                    <td>{{ mensagem.ultimoUsuario || '---' }}</td>
                    <td>{{ mensagem.descricao || '---' }}</td>
                    <td>
                      <router-link class="btn btn-primary btn-xs"
                                   active-class=""
                                   v-tooltip="'Relatório'"
                                   :to="{ name: relatorio(mensagem.modulo, mensagem.descricao, mensagem.tipoSolicitacao), params: { id: mensagem.numero, rota: 'mensagem' } }">
                        <i class="fa fa-file-text-o"></i>
                      </router-link>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos'"
                              @click="mostrarModalArquivos(mensagem.numero, mensagem.modulo)"
                              v-if="configuracao.usarArquivosSolicitacaoCompras">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              @click="mostrarModalMensagem(mensagem.id, mensagem.numero, mensagem.modulo)"
                              v-if="!configuracao.naoUtilizarMensageria">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="8">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/mensagem/componentes/Mensagem.vue